import { isSuccessStatus } from '@utils/statusSuccess'
import { LoginForInviteRequestBodySignUpTypeEnum } from '../swagger'
import { auth } from './swagger'

export const loginForInvite = async (
  credentials: {
    username: string
    password: string
  },
  signUpType: LoginForInviteRequestBodySignUpTypeEnum,
  typeIdentifier: string
): Promise<boolean> => {
  try {
    const response = await auth.loginForInviteRaw({
      body: { credentials, signUpType, typeIdentifier },
    })

    return isSuccessStatus(response.raw.status)
  } catch (error) {
    return false
  }
}

export const login = async (credentials: {
  email: string
  password: string
}): Promise<boolean> => {
  try {
    const response = await auth.loginRaw({
      body: { username: credentials.email, password: credentials.password },
    })
    return isSuccessStatus(response.raw.status)
  } catch (error) {
    return false
  }
}

export const updateLogin = async (actorKey?: number): Promise<boolean> => {
  try {
    const response = await auth.updateLoginRaw({
      body: { actorKey },
    })
    return isSuccessStatus(response.raw.status)
  } catch (error) {
    return false
  }
}
export default login
